<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="订单状态：">
              <el-radio-group v-model="tableFrom.status" type="button" @change="getList(1)">
                <el-radio-button label="">全部 {{ '(' +orderChartType.all?orderChartType.all:0 + ')' }}</el-radio-button>
                <el-radio-button
                  label="3"
                >待鉴定 {{ '(' +orderChartType.noAppraisal?orderChartType.noAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="4"
                >已收货 {{ '(' +orderChartType.deliveryAppraisal?orderChartType.deliveryAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="5"
                >已鉴定 {{ '(' +orderChartType.yesAppraisal?orderChartType.yesAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="6"
                >已回寄 {{ '(' +orderChartType.postAppraisal?orderChartType.postAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="8"
                >已回收 {{ '(' +orderChartType.platformAppraisal?orderChartType.platformAppraisal:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="鉴别状态：">
              <el-radio-group v-model="tableFrom.product_status" type="button" @change="getList(1)">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button
                  label="1"
                >真 {{ '(' +orderChartType.realAppraisal?orderChartType.realAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="2"
                >假 {{ '(' +orderChartType.failAppraisal?orderChartType.failAppraisal:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item,i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                >{{ item.text }}</el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px;"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="寄件类型：" style="display: inline-block;">
              <el-select
                v-model="tableFrom.express_type"
                clearable
                placeholder="请选择"
                class="selWidth"
                @change="getList(1)"
              >
                <el-option label="自行寄件" value="1" />
                <el-option label="预约上门寄件" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="后台回收状态：" style="display: inline-block;">
              <el-select
                v-model="tableFrom.product_is_recovery"
                clearable
                placeholder="请选择"
                class="selWidth"
                @change="getList(1)"
              >
                <el-option label="可以回收" value="1" />
                <el-option label="不能回收" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="用户回收状态：" style="display: inline-block;">
              <el-select
                v-model="tableFrom.product_user_status"
                clearable
                placeholder="请选择"
                class="selWidth"
                @change="getList(1)"
              >
                <el-option label="愿意回收" value="1" />
                <el-option label="不愿意回收" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="分类名称：" style="display: inline-block;">
              <el-cascader
                v-model="tableFrom.category_id"
                class="selWidth"
                :options="appraisalCateList"
                :props="props"
                clearable
                @change="getList(1)"
              />
            </el-form-item>
            <el-form-item label="物流单号：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.product_express_num"
                @keyup.enter.native="getList(1)"
                placeholder="请输入物流单号"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
            <el-form-item label="关键字：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号/产品序号/收货人/联系方式"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
            <el-form-item label="用户信息：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.username"
                @keyup.enter.native="getList(1)"
                placeholder="请输入用户昵称/手机号"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="appraisal_order_id"
          min-width="50" />
        <el-table-column
          label="订单号"
          prop="order_sn"
          min-width="150" />
        <el-table-column
          label="用户昵称"
          prop="user.nickname"
          min-width="100" />
        <el-table-column
          label="品类"
          prop="cateOne.cate_name"
          min-width="100" />
        <el-table-column
          label="品牌"
          prop="cateTwo.cate_name"
          min-width="100" />
        <el-table-column
          label="系列"
          prop="cateThree.cate_name"
          min-width="100" />
        <el-table-column
          label="商品型号"
          prop="product_number"
          min-width="100" />
        <el-table-column
          label="收件人"
          prop="user_name"
        <el-table-column
          label="收件电话"
          prop="user_phone"
          min-width="100" />
        <el-table-column
          label="快递单号"
          prop="product_express_num"
          min-width="150" />
        <el-table-column
          label="商品购买渠道"
          prop="product_purchase_channel"
          min-width="100" />
        <el-table-column
          label="状态"
          prop="status_text"
          min-width="100" />
        <el-table-column
          label="鉴定状态"
          prop="product_status_text"
          min-width="100" />
        <el-table-column
          label="平台状态"
          prop="product_is_recovery_text"
          min-width="100" />
        <el-table-column
          label="用户状态"
          prop="product_user_status_text"
          min-width="100" />
        <el-table-column
          label="创建时间"
          prop="create_time"
          min-width="160" />
        <el-table-column label="操作" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onDetail(scope.row.appraisal_order_id)">详情</el-button>
            <el-button type="text" size="small" v-if = 'scope.row.status == 4 ||scope.row.status == 5 || (scope.row.status == 3 && scope.row.express_type == 1) || (scope.row.status == 3 && scope.row.express_type == 2 && scope.row.order_express.express_pay == 1)' @click="onEdit(scope.row.appraisal_order_id,scope.row)">编辑状态</el-button>
            <el-button type="text" size="small" v-if = 'scope.row.express_type == 2 && scope.row.order_express.express_status == 0' @click="onCancelExpress(scope.row.appraisal_order_id,scope.row)">取消寄件</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row.appraisal_order_id, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <el-dialog v-if="dialogVisible" title='详情' :visible.sync="dialogVisible" width="700px">
      <div v-loading="loading" class="divBox">
        <el-card class="box-card">
          <el-form ref="formData"   label-width="120px" class="demo-ruleForm">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="订单ID：">
                  <div>{{formData.appraisal_order_id}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单号：">
                  <div>{{formData.order_sn}}</div>
                </el-form-item>
              </el-col>
              <el-form-item label='图片：'>
                <div v-for="(item, index) in formData.slide_image" :key="index" style="display: inline-block; margin: 0 10px 10px 0">
                  <el-image
                    style="width: 80px; height: 80px"
                    :src="item || ''"
                    :preview-src-list="[item?item:'']"
                  />
                </div>
              </el-form-item>
              <el-col :span="12">
                <el-form-item label="型号：">
                  <div>{{formData.product_number}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物流单号：">
                  <div>{{formData.product_express_num}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="渠道：">
                  <div>{{formData.product_purchase_channel}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="描述：">
                  <div>{{formData.product_content}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="品类：" v-if = 'formData.cate'>
                  <div>{{formData.cate.cate_name}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="品牌：" v-if = 'formData.brand'>
                  <div>{{formData.brand.brand_name}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户：" v-if = 'formData.user'>
                  <span>{{formData.user.nickname}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户ID：" v-if = 'formData.user'>
                  <span>{{formData.user.uid}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="寄件类型：">
                  <span>{{formData.express_type == 1 ? '自行寄件' : '预约上门'}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="寄件地址：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.express_address}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="寄件人：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.express_name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="寄件电话：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.express_phone}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="商品重量：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.express_weight}}KG</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物流创建时间：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.create_time}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="取件时间：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.express_day_type}} {{formData.order_express.express_pickup_start}}-{{formData.order_express.express_pickup_end}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="物流公司：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.product_express_company}} {{formData.order_express.express_num}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="邮费：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.express_price}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物流状态：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.express_status == 0 ? '提交订单，待取件' : (formData.order_express.express_status == 1 ? '已取件' : (formData.order_express.express_status == 2 ? '已支付' : '已取消')) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物流支付状态：" v-if="formData.express_type == 2">
                  <span>{{formData.order_express.express_pay == 1 ? '已支付' : '未支付' }}</span>
                </el-form-item>
              </el-col>
              <el-form-item label="状态：">
                <span>{{formData.status_text}}</span>
              </el-form-item>
              <el-col :span="12">
                <el-form-item label="物品状态：" v-if="formData.status >= 5">
                  <span>{{formData.product_status_text}}</span>
                </el-form-item>
              </el-col>
              <el-form-item label="真假说明：" v-if="formData.status >= 5">
                <span>{{formData.product_status_desc}}</span>
              </el-form-item>
              <el-form-item label="回收状态：" v-if="formData.product_status == 1">
                <span>{{formData.product_user_status_text}}</span>
              </el-form-item>
              <el-col :span="12">
                <el-form-item label="回收价格：" v-if="formData.product_status == 1">
                  <span>{{formData.recovery_price}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回收备注：" v-if="formData.product_status == 1">
                  <span>{{formData.recovery_remark}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回寄物流公司：" v-if="formData.product_status == 2 || formData.product_user_status == 2">
                  <span>{{formData.product_return_company}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回寄单号：" v-if="formData.product_status == 2 || formData.product_user_status == 2">
                  <span>{{formData.product_return_num}}</span>
                </el-form-item>
              </el-col>
              <el-form-item label="创建时间：">
                <span>{{formData.create_time}}</span>
              </el-form-item>
              <el-form-item label="用户地址" prop="refusal">
                <el-input v-model="formData.user_address" type="textarea" placeholder="用户地址" />
              </el-form-item>
              <el-form-item label="用户电话" prop="refusal">
                <el-input v-model="formData.user_phone" type="textarea" placeholder="用户电话" />
              </el-form-item>
              <el-form-item label="联系人" prop="refusal">
                <el-input v-model="formData.user_name" type="textarea" placeholder="联系人" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">提交</el-button>
              </el-form-item>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  appraisalBrandDeleteApi,
  appraisalBrandListApi,
  appraisalBrandSelectListApi,
  appraisalCategoryMenuListApi,
  appraisalCateSelectListApi,
  appraisalEntityCardListApi,
  appraisalEntityChartListApi,
  appraisalEntityListApi,
  appraisalEntityOrderCancelExpressApi,
  appraisalEntityOrderDeleteApi,
  appraisalOrderEntityAuditApi,
  appraisalOrderEntityDetailApi,
  appraisalOrderEntityUpdateApi,
} from "@/api/appraisal";
import {fromList} from "@/libs/constants";
import {communityAuditApi, communityDetailApi, communityUpdateApi} from "@/api/community";
export default {
  name: 'appraisalEntityOrder',
  components: {},
  data() {
    return {
      props: { checkStrictly: true, emitPath: false},
      moren: require("@/assets/images/f.png"),
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      roterPre: roterPre,
      tableFrom: {
        page: 1,
        limit: 20,
      },
      orderChartType: {},
      fromList: fromList,
      cardLists: [],
      timeVal: [],
      dialogVisible:false,
      loading: false,
      formData: {},
      ruleForm:{},
      appraisal_order_id:'',
      appraisalCateList:[],
    }
  },
  mounted() {
    this.getList(1)
    this.headerList()
    this.appraisalMenuCategory()
  },
  methods: {
    appraisalMenuCategory() {
      appraisalCategoryMenuListApi(3)
        .then((res) => {
          console.log(res.data)
          this.appraisalCateList = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    onSubmit() {
      this.ruleForm.user_address = this.formData.user_address;
      this.ruleForm.user_phone = this.formData.user_phone;
      this.ruleForm.user_name = this.formData.user_name;
      appraisalOrderEntityAuditApi(this.appraisal_order_id,this.ruleForm).then(res => {
        this.$message.success(res.message)
        this.dialogVisible = false
        this.getList('')
      }).catch(res => {
        this.$message.error(res.message)
      })
    },
    // 详情
    onDetail(id) {
      this.appraisal_order_id = id;
      this.dialogVisible = true;
      this.isExamine = false;
      appraisalOrderEntityDetailApi(id).then((res) => {
        this.formData = res.data
      }).catch(({ message }) => {
        this.$message.error(message)
      })
    },
    // 编辑
    onEdit(id,data) {
      if(data.status == 5 && data.product_status == 1 && data.product_is_recovery == 1 && data.product_user_status == 0)
      {
        this.$message.success('等待确认是否原因被回收中，等用户确认后才能下一步操作');
      }
      else
      {
        this.$modalForm(appraisalOrderEntityUpdateApi(id)).then(() => this.getList(''))
      }

    },
    headerList() {
      appraisalEntityChartListApi()
        .then((res) => {
          this.orderChartType = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    getCateSelect()
    {
      appraisalCateSelectListApi()
        .then((res) => {
          this.cateSelect = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    getBrandSelect()
    {
      appraisalBrandSelectListApi()
        .then((res) => {
          this.brandSelect = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 选择时间
    selectChange(tab) {
      this.tableFrom.date = tab;
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.date = e ? this.timeVal.join("-") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },
    // 列表
    getList(num) {
      this.listLoading = true
      this.tableFrom.page = num ? num : this.tableFrom.page
      this.tableFrom.appraisal_type_list = 1;
      appraisalEntityListApi(this.tableFrom).then(res => {
        this.tableData.data = res.data.list
        this.tableData.total = res.data.count
        this.listLoading = false
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    pageChange(page) {
      this.tableFrom.page = page
      this.getList('')
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val
      this.getList('')
    },
    // 删除
    handleDelete(id, idx) {
      this.$modalSure('确定删除该鉴定吗？').then(() => {
        appraisalEntityOrderDeleteApi(id).then(({ message }) => {
          this.$message.success(message)
          this.getList('')
        }).catch(({ message }) => {
          this.$message.error(message)
        })
      })
    },
    //取消寄件
    onCancelExpress(id, idx) {
      this.$modalSure('确定取消寄件吗？').then(() => {
        appraisalEntityOrderCancelExpressApi(id).then(({ message }) => {
          this.$message.success(message)
          this.getList('')
        }).catch(({ message }) => {
          this.$message.error(message)
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.box-container {
  overflow: hidden;
}
.box-container .list {
  float: left;
  line-height: 40px;
}
.box-container .sp {
  width: 50%;
}
.box-container .sp3 {
  width: 33.3333%;
}
.box-container .sp100 {
  width: 100%;
}
.box-container .list .name {
  display: inline-block;
  width: 150px;
  text-align: right;
  color: #606266;
}
.box-container .list.image {
  margin-bottom: 40px;
}
.box-container .list.image img {
  position: relative;
  top: 40px;
}
/deep/.el-form-item__content .el-rate{
  position: relative;
  top: 8px;
}
</style>
